import axios from "axios";
import axiosInstance from "./axiosInstance";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const profileApi = {
  getProfile: () => axiosInstance.get("/profile"),

  updateProfile: (data) => axiosInstance.put("/profile", data),

  getQualifications: () =>
    axiosInstance.get("/profile/professional-qualifications"),

  addQualification: (data) =>
    axiosInstance.post("/profile/professional-qualifications", data),

  getExperiences: () => axiosInstance.get("/profile/experience"),

  addExperience: (data) => axiosInstance.post("/profile/experience", data),

  getEducations: () => axiosInstance.get("/profile/education"),

  addEducation: (data) => axiosInstance.post("/profile/education", data),

  getCertificates: () => axiosInstance.get("/profile/certificates"),

  addCertificate: (data) => axiosInstance.post("/profile/certificates", data),

  uploadFile: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const token = localStorage.getItem("jwtToken");
    return axios.post(`${BASE_URL}/profile/upload`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        // No Content-Type — let browser set multipart/form-data with boundary automatically
      },
    });
  },
};

export default profileApi;
